module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-5000-Classes-Inactive-6a5c0f667b6dcfbff1f352241ac696f2.png";